// Variables
var lang = $('html').attr('lang'),
    body = $('body'),
    windowWidth;

$(document).ready(function () {

    /* ----------------------------------------------
       Generic Functions
    /* ---------------------------------------------*/

    if ($('body').hasClass('producers-map')) {

        // init first GoogleMaps
        getAllProducers('true');

        // init Autocomplete
        getAutocomplete();

        //getOptionsBrands();

        // select2 for brands
        /*$("#brands").select2({
            theme: "classic",
            width: 'resolve',
        });*/

        // on click on icon search show form
        $('.searchIcon').on('click', function () {
            $(this).hide();
            $('#searchForm').fadeIn();
        });

        // on key up on input store
        $('#store').on('keyup', function () {

            var searchProducerName = $(this).val();

            // show option after 2 caracts
            if(searchProducerName.length >= 2 && isNaN(searchProducerName)) {

                showOptions(searchProducerName);
                $(this).removeClass('errorInput');

            } else {

                $(this).addClass('errorInput');
                $('#stores').html('<ul></ul>');

            }

        });

        $('#zipCode').on('keyup', function() {
            var zipCodeVal = $('#zipCode').val();
            var ac = new google.maps.places.Autocomplete(zipCodeVal, {
                // limit to regions
                types: ['(regions)'],
                // limit to belgium
                componentRestrictions: {country: 'be'},
                // limit to radius
                radius: 250
            });
            var brandsVal = $('#brands').val();
            // check if brands exists in ctec points
            getCtecPointsInRadius(brandsVal, ac);
        });

        /*$('#brands').on('change', function () {
            $('#store').val('');
            var zipCodeVal = $('#zipCode').val();
            var brandsVal = $(this).val();
            if (zipCodeVal.length == 0 && brandsVal) {
                getStoreByBrands(brandsVal, function (output) {
                    if (output) {
                        // save search as json
                        saveStat({"brands": brandsVal});
                        // remove error message and info brands searched
                        $('.errorForm').html('');
                        $('.infoBrandsSearched').html('');
                    } else {
                        var error = '<div><small>Store doesn\'t exist</small></div>';
                        $('.errorForm').html(error);
                    }
                });
            }
        });*/

        $('#back').on('click', function () {
            $('#details').hide();
            $('#searchForm').show();
        });

        // disabled search by zip and brands
        $('#producerName').on('click', function () {
            $('#options #zipCode, #options #brands, .select2-container--classic .select2-selection--multiple, .select2-container--classic .select2-selection--multiple input').addClass('disabled');
            $('#store').removeClass('disabled');
            $('#store').removeClass('errorInput');
            $('#zipCode').val('');
        });

        // disabled search by store
        $('#options').on('click', function () {
            $('#store').addClass('disabled');
            $('#options #zipCode, #options #brands, .select2-container--classic .select2-selection--multiple, .select2-container--classic .select2-selection--multiple input').removeClass('disabled');
            $('#store').removeClass('errorInput');
        });
    }
});

/* -----------------------
 Function on resize
/* ------------------------ */

$(window).resize(function () {
    windowWidth = $(this).width();
});

/**
 * @function init GoogleMaps object and marker(s)
 * @param data
 */
function initGoogleMaps(data, init) {
    setTimeout(function () {
        if (data.length != 0) {
            // if init is true less zoom
            if (init) {
                var zoom = 8;
                // if init is false more zoom
            } else {
                var zoom = 11;
            }
            // get the position center
            if (typeof data.length == "undefined") {
                var first = {lat: parseFloat(data.details.miammm.geoloc.lat), lng: parseFloat(data.details.miammm.geoloc.lng)};
            } else {
                var first = {lat: parseFloat(data[0].details.miammm.geoloc.lat), lng: parseFloat(data[0].details.miammm.geoloc.lng)};
            }
            // The map, centered at first coord
            var map = new google.maps.Map(document.getElementById('map'),
                {
                    zoom: zoom,
                    center: first,
                    fullscreenControl: false,
                    mapTypeControl: true,
                    mapTypeControlOptions: {
                        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                        position: google.maps.ControlPosition.TOP_RIGHT
                    },
                    styles: [
                        {"featureType": "all", "elementType": "all", "stylers": [{"visibility": "on"}]}, {"featureType": "all", "elementType": "labels.text", "stylers": [{"visibility": "on"}, {"hue": "#ff0000"}]}, {
                            "featureType": "administrative",
                            "elementType": "all",
                            "stylers": [{"visibility": "on"}]
                        }, {"featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{"color": "#444444"}]}, {"featureType": "landscape", "elementType": "all", "stylers": [{"color": "#f2f2f2"}]}, {
                            "featureType": "poi",
                            "elementType": "all",
                            "stylers": [{"visibility": "off"}]
                        }, {"featureType": "road", "elementType": "all", "stylers": [{"saturation": -100}, {"lightness": 45}]}, {"featureType": "road", "elementType": "labels.text", "stylers": [{"visibility": "on"}]}, {
                            "featureType": "road.highway",
                            "elementType": "all",
                            "stylers": [{"visibility": "simplified"}]
                        }, {"featureType": "road.arterial", "elementType": "labels.icon", "stylers": [{"visibility": "off"}]}, {"featureType": "transit", "elementType": "all", "stylers": [{"visibility": "off"}]}, {
                            "featureType": "water",
                            "elementType": "all",
                            "stylers": [{"color": "#e6a492"}, {"visibility": "on"}]
                        }
                    ]
                }
            );
            // create one or many markers depends on data.length
            if (typeof data.length == "undefined") {
                createMarker(data, map);
            } else {
                createMarkers(data, map);
            }
            $('.errorForm').html('');
        } else {
            var error = '<div><small>Store doesn\'t exist</small></div>';
            $('.errorForm').html(error);
        }
    }, 100);
}

/**
 * @function create all markers GoogleMaps
 * @param data
 * @param map
 */
function createMarkers(data, map) {


    // array of marker
    var markers = new Array();

    for (var key in data) {
        var store = data[key].name;
        var lat = parseFloat(data[key].details.miammm.geoloc.lat);
        var lng = parseFloat(data[key].details.miammm.geoloc.lng);
        // The location of store
        var coord = {lat: lat, lng: lng};
        var myIcon = new google.maps.MarkerImage('img/marker.png', null, new google.maps.Point(0, 0), new google.maps.Point(18, 20), new google.maps.Size(36, 41));
        // The marker, positioned at coord of the store
        var marker = new google.maps.Marker(
            {
                position: coord,
                map: map,
                id: data[key].id,
                name: data[key].name,
                icon: myIcon
            }
        );
        markers.push(marker);
    }

    for (var key in markers) {
        // list on click on one marker
        markers[key].addListener('click', function () {
            var currentId = $(this)[0].id;
            getInfosById(currentId);
        });
    }
}

/**
 * @function create one marker GoogleMaps
 * @param data
 * @param map
 */
function createMarker(data, map) {

    // array of marker
    var markers = new Array();

    var store = data.name;
    var lat = parseFloat(data.data.geoloc.lat);
    var lng = parseFloat(data.data.geoloc.lng);
    // The location of store
    var coord = {lat: lat, lng: lng};
    // images - ? - origin - anchor - size - 26x30 - 50-58
    var myIcon = new google.maps.MarkerImage('images/map/marker.png', null, new google.maps.Point(0, 0), new google.maps.Point(18, 20), new google.maps.Size(36, 41));
    // The marker, positioned at coord of the store
    var marker = new google.maps.Marker({
        position: coord,
        map: map,
        id: data.id,
        name: data.name,
        icon: myIcon
    });
    markers.push(marker);

    for (var key in markers) {
        // list on click on one marker
        markers[key].addListener('click', function () {
            var currentId = $(this)[0].id;
            getInfosById(currentId);
        });
    }
}


function producerExists(producerName, producerId, callBackFct) {

    $.ajax({
        url: lang + '/ajax',
        type: 'POST',
        dataType: 'json',
        data: {
            function: 'producerExists',
            id: producerId
        },
        success: function (data) {
            if (data == null) {
                callBackFct(false);
            } else {
                callBackFct(true);
            }
        },
        error: function (e) {
        }
    });
}


function getAllProducers(callback) {

    $.ajax({
        url: lang + '/ajax',
        type: 'POST',
        dataType: 'json',
        data: {
            function: 'getAllProducers'
        },
        success: function (data) {

            for (var key in data) {
                data[key].details = JSON.parse(data[key].details);
            }

            if (callback == "true") {
                initGoogleMaps(data, true);
            } else {
                callback(data);
            }
        },
        error: function (e) {
            console.log(e.responseText);
        }
    });
}

function showOptions(producerName) {

    $.ajax({
        url: lang + '/ajax',
        type: 'POST',
        dataType: 'json',
        data: {
            function: 'getProducersByName',
            name: producerName
        },
        success: function (data) {

            var options = '';

            $.each(data, function (k, v) {

                var name = data[k].name;
                var id = data[k].id;
                options += "<li class=\"list-group-item\" value='" + id + "'>" + name + "</li>";

            });

            $('#producers').html(options);

            // on click on option
            $('#producers li').on('click', function () {

                var producerId = $(this).attr('value');
                var producerName = $(this).text();

                // Replace ' with \' to avoid ajax error
                producerName = producerName.replace("'", "\\'");

                // check if store exists
                producerExists(producerName, producerId, function (output) {

                    if(output) {

                        // if store input is completed
                        if (producerId) {

                            getInfosById(producerId);
                            getProducerByName(producerName);

                            // save search as json
                            //saveStat({"producerId": producerId});

                            // remove error message and info brands searched
                            $('.errorForm').html('');

                            // clear brands and stores inputs
                            $('#producers').html('<ul></ul>');
                            //$('#brands').val(null).trigger('change');
                            // replace \' by apostrophe to show correctly
                            $('#store').val(producerName.replace("\\'", "'"));
                        }

                    } else {
                        var error = '<div><small>Store doesn\'t exist</small></div>';
                        $('.errorForm').html(error);
                    }

                });

            });

        },
        error: function (e) {

            // Show error log
            console.log(e.responseText);

        }
    });
}


function getInfosById(producerId) {

    $.ajax({
        url: lang + '/ajax',
        type: 'POST',
        dataType: 'json',
        data: {
            function: 'getProducerDetailById',
            producer_id: producerId
        },
        success: function (data) {

            // hide search icon or/and search form on click on marker to show infos about store
            $('#searchForm').hide();
            $('.searchIcon').hide();

            // refresh all span empty
            $('#details span').text('');

            // add datas in div data that show all info by store
            $('#details .prodLogo').html('<img src="'+data.miammm.logo+'" />');
            $('#details .store').text(data.miammm.name[1]);
            $('#details .street').text(data.address.street);
            $('#details .number').text(data.address.number);
            $('#details .zip').text(data.address.zip);
            $('#details .city').text(data.address.city);

            $('#details').show();

        },
        error: function (e) {
            //console.log(e.responseText);
        }
    });
}

function checkIfNotEmpty(value, where, link) {
    if (link) {
        var atIn = /@/;
        var find = value.match(atIn);
        // if website is empty
        if (value && find === null) {
            // remove display none
            $(where).parent().css({'display': 'block'});
            // check if website start with http
            if (value.substr(0, 4) == 'http') {
                $(where).html('<a href="' + value + '" target="_blank">' + value.substr(value.indexOf(":") + 3) + '</a>');
            } else {
                $(where).html('<a href="http://' + value + '" target="_blank">' + value + '</a>');
            }
        } else {
            // add display none
            $(where).parent().css({'display': 'none'});
        }
    } else {
        if (value) {
            // remove display none
            $(where).parent().css({'display': 'block'});
            // add value to html
            $(where).html(value);
        } else {
            // add display none
            $(where).parent().css({'display': 'none'});
        }
    }
}

/**
 * @function get all brands
 * @param brandsArray
 */
function getBrands(brandsArray) {
    $.ajax({
        url: lang + '/ajax',
        type: 'POST',
        dataType: 'json',
        data: {
            function: 'getBrandsByIds',
            brands_ids: brandsArray
        },
        success: function (data) {
            var txt = '';
            // create span with all brands
            $.each(data, function (k, v) {
                txt += '<span class="badge">' + v + '</span> ';
            });
            if (!data) {
                $('#datas .brands').parent().css({'display': 'none'});
            } else {
                $('#datas .brands').parent().css({'display': 'block'});
                // add all brands into .marques
                $('#datas .brands').html(txt);
            }
        },
        error: function (e) {
            // console.log(e.responseText);
        }
    });
}

/*
function getOptionsBrands() {
    $.ajax({
        url: lang + '/ajax',
        type: 'POST',
        dataType: 'json',
        data: {
            function: 'getAllBrands'
        },
        success: function (data) {
            // store all select > options
            var options = '';
            // create all option for form select brands
            $.each(data, function (k, v) {
                var name = v.name;
                var id = v.id;
                options += '<option class="text-secondary" value="' + id + '">' + name + '</option>';
            });
            // send options in select > option
            $('#brands').html(options);

        },
        error: function (e) {
            //console.log(e.responseText);
        }
    });
}*/

/**
 * @function get infos about store(s) searched by name
 * @param name
 */
function getProducerByName(name) {

    $.ajax({
        url: lang + '/ajax',
        type: 'POST',
        dataType: 'json',
        data: {
            function: 'getProducerByName',
            name: name
        },
        success: function (data) {
            // parse json to string to use them into googleMaps object
            //data.data = JSON.parse(data.data);
            // init GoogleMaps object
            initGoogleMaps(data, false);
        },
        error: function (e) {
            console.log(e.responseText);
        }
    });
}

/**
 * @function reload map and marker by brands selected
 * @param listOfBrands
 * @param callBackFct
 */
function getStoreByBrands(listOfBrands, callBackFct) {
    if (listOfBrands.length > 0) {
        $.ajax({
            url: lang + '/ajax',
            type: 'POST',
            dataType: 'json',
            data: {
                function: 'getStoreByBrands',
                brands_ids: listOfBrands
            },
            success: function (data) {
                if (data == null) {
                    callBackFct(false);
                } else {
                    callBackFct(true);
                    // if data contains one or many objects
                    if (data.length >= 1) {
                        for (var key in data) {
                            // parse to json on each object
                            data[key].data = JSON.parse(data[key].data);
                        }
                    } else {
                        // parse json to string
                        data.data = JSON.parse(data.data);
                    }
                    // init GoogleMaps object
                    initGoogleMaps(data, false);
                }
            },
            error: function (e) {
                //console.log(e.responseText);
            }
        });
    }
}


function saveStat(producerId) {

    $.ajax({
        url: lang + '/ajax',
        type: 'POST',
        dataType: 'json',
        data: {
            function: 'storeStat',
            producerId: producerId
        }
    });

}


function getAutocomplete() {

    // get google maps method autocomplete
    var ac = new google.maps.places.Autocomplete(document.getElementById('zipCode'), {
        // limit to regions
        types: ['(regions)'],
        // limit to belgium
        componentRestrictions: {country: 'be'},
        // limit to radius
        radius: 250
    });

    // add event listener on change
    google.maps.event.addListener(ac, 'place_changed', function () {
        $('#store').val('');
        var brandsVal = $('#brands').val();
        // check if brands exists in ctec points
        getCtecPointsInRadius(brandsVal, ac);
        // remove error message and info brands searched
        $('.errorForm').html('');
    });
    $('#brands').on('change', function () {
        var zipCodeVal = $('#zipCode').val();
        var brandsVal = $(this).val();
        if (zipCodeVal.length != "" && brandsVal) {
            getCtecPointsInRadius(brandsVal, ac);
        }
    });

}

/**
 * @function return ctec points are in radius
 * @param brandsVal
 * @param ac
 */
function getCtecPointsInRadius(brandsVal, ac) {
    // check value of brands
    if (brandsVal == "") {
        brandsVal = "undefined";
    }
    // get place at every changes
    var place = ac.getPlace();
    // get lat and lng
    var lat = place.geometry.location.lat();
    var lng = place.geometry.location.lng();
    var LatLng = new Array(lat, lng);


    function getZipCode(callback) {
        $.ajax({
            url: 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lng + '&key=AIzaSyA_Mw_wVRnI7mRQiITi_iQhtX8G67UMvWc',
            method: 'GET',
            responseType: 'application/json',
            dataType: 'json',
            success: function (data) {
                var firstComponent = data.results[0].address_components;
                var zipCode;
                for (var key in firstComponent) {
                    if (firstComponent[key].types == 'postal_code') {
                        zipCode = firstComponent[key].long_name;
                    }
                }
                callback(zipCode);
            },
            error: function (e) {
                console.log(e);
            }
        });
    }

    getZipCode(function (zipCode) {
        // call function get AllShops to check which ctec points are in the radius
        getAllProducers(function (output) {
            calculDistance(output, LatLng, brandsVal, zipCode);
        });
    })
}

/**
 * @function check which ctec point is in the radius
 * @param data
 * @param geolocOnChange
 * @param array of brands
 */
function calculDistance(data, geolocOnChange, valBrands, zipCode) {
    // 1 save search as json
    if (geolocOnChange && valBrands != "undefined") {
        saveStat({"geoloc": geolocOnChange, "brands": valBrands});
    }
    if (geolocOnChange && valBrands == "undefined") {
        saveStat({"geoloc": geolocOnChange});
    }
    // 2 loop on data (ctec points)
    var ctecPoints = new Array();
    //var ctecPointsByZipCode = new Array();
    // 3 if you want to change radius, change here
    var radius = 22;
    // 4 loop on ctec points
    for (var key in data) {
        // prepare destination
        var lat = parseFloat(data[key].data.geoloc.lat);
        var lng = parseFloat(data[key].data.geoloc.lng);

        // 5 to calcul the distance in km
        var distance = calcCrow(geolocOnChange[0], geolocOnChange[1], lat, lng).toFixed(1);
        if (isNaN(distance)) {
            var status = false;
        } else {
            var status = true;
        }
        if (status) {
            // 6 save only in radius
            if (distance <= radius) {
                // A STOCKER DANS UN TABLEAU -> INIT MARKERS DIFFERENTS
                if (data[key].data.address.zip == zipCode) {
                    data[key]['flag'] = 'yellow';
                    ctecPoints.push(data[key]);
                } else {
                    ctecPoints.push(data[key]);
                }
            }
        }
    }
    /** CHECK BELOW vvv **/
    // array to store ctec points provide brands
    var ctecPointsValid = [];
    // check if one or many brands are selected by user
    if (valBrands != "undefined") {
        // loop on all ctec points in the radius
        for (var index in ctecPoints) {
            // get brands array and parse json to array
            var brands = JSON.parse(ctecPoints[index].brands);
            // loop on valBrands = brands selected by user
            for (var cle in valBrands) {
                // loop on brands array of the current ctec point
                for (var key in brands) {
                    // if brand is in array
                    if (brands[key] == valBrands[cle]) {
                        ctecPointsValid.push(ctecPoints[index]);
                    }
                }
            }
        }
    } else {
        // if no brands show all ctec points in the area
        ctecPointsValid = ctecPoints;
    }
    //console.log(ctecPointsByZipCodeValid);
    // // 4 call onction qui fait les markers et les ajoute à la map qui a été init
    if (typeof geolocOnChange != "undefined") {
        initGoogleMaps(ctecPointsValid, false);
    }

}

//This function takes in latitude and longitude of two location and returns the distance between them as the crow flies (in km)
function calcCrow(lat1, lon1, lat2, lon2) {
    var R = 6371; // km
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var lat1 = toRad(lat1);
    var lat2 = toRad(lat2);

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
}

// Converts numeric degrees to radians
function toRad(Value) {
    return Value * Math.PI / 180;
}
